export const DEINCREMENT = 'DEINCREMENT';
export const INCREMENT = 'INCREMENT';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const EXPRIED = 'EXPRIED';
export const CLOSE_EXPRIED = 'CLOSE_EXPRIED';
export const SET_PROFILE = 'SET_PROFILE';

export const SUBSCRIBE = 'SUBSCRIBE';
export const CHANGE_FILTER = 'CHANGE_FILTER';
export const CHANGE_TIME = 'CHANGE_TIME';
export const CHANGE_RANGE = 'CHANGE_RANGE';

export const ANALYST = 'ANALYST';
export const CHANGE_PLAN = 'CHANGE_PLAN';
